import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { If } from 'src/Components'
import Button from 'src/Components/shared/Button'
import Text from 'src/Components/shared/Text'
import StatusIcon from 'src/Components/shared/StatusIcon'
import PrequalContactEmailLink from './PrequalContactEmailLink'
import PrequalContactPhoneLink from './PrequalContactPhoneLink'

import styles from './PrequalRequested.module.scss'

const propTypes = {
  success: PropTypes.bool,
  error: PropTypes.bool,
  onClose: PropTypes.func
}

const emailLink = <PrequalContactEmailLink />
const phoneLink = <PrequalContactPhoneLink />

const PrequalRequested = ({ className, name, success, error, onClose }) => (
  <div className={className}>
    <StatusIcon
      className={styles.icon}
      spin={!success && !error}
      success={success}
      failure={error}
    />
    <If condition={!success && !error}>
      <Text size='xl' weight='light'>
        <FormattedMessage
          id='Affordability.promptPrequal.requested.inFlight'
          defaultMessage='Contacting {name}...'
          values={{
            name
          }}
        />
      </Text>
    </If>
    <If condition={success}>
      <Text size='xl' weight='light'>
        <FormattedMessage
          id='Affordability.promptPrequal.requested.successMain'
          defaultMessage='Great! {name} has been notified and will be in contact shortly.'
          values={{ name }}
        />
      </Text>
      <Text size='s' color='quiet'>
        <FormattedMessage
          id='Affordability.promptPrequal.requested.successSub'
          defaultMessage='Can’t wait? {email_link} or call at {phone_link}'
          values={{
            email_link: emailLink,
            phone_link: phoneLink
          }}
        />
      </Text>
    </If>
    <If condition={error}>
      <Text size='xl' weight='light'>
        <FormattedMessage
          id='Affordability.promptPrequal.requested.errorMain'
          defaultMessage='Request failed, unable to contact {name}.'
          values={{
            name
          }}
        />
      </Text>
      <Text size='s' color='quiet'>
        <FormattedMessage
          id='Affordability.promptPrequal.requested.errorSub'
          defaultMessage='Alternatively, you may {email_link} directly or call at {phone_link}'
          values={{
            email_link: emailLink,
            phone_link: phoneLink
          }}
        />
      </Text>
    </If>
    <Button
      className={styles.close}
      primary
      onClick={onClose}
      data-qa='prequalPrompt.closeButton'
    >
      <FormattedMessage id='Prompt.close' defaultMessage='Close' />
    </Button>
  </div>
)

PrequalRequested.propTypes = propTypes

export default PrequalRequested
